import { render } from "./EventDetails.vue?vue&type=template&id=571b7aa1"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import exportComponent from "D:\\code\\vue practice\\vue mastery\\real world vue 3\\7. Deploying with Render\\deploying-with-render\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__